import {observer} from 'mobx-react';
import {useCallback} from 'react';
import Card, {CardBody, CardHeader, CardTitle} from '../../../components/bootstrap/Card';
import Icon from '../../../components/icon/Icon';
import {useMst} from '../../../models';
import {useTranslation} from 'react-i18next';
import { getPersonDisplayName } from 'helpers/personNameI18n';
import { getLocalizedFieldOrI18n } from 'helpers/localizedField';

const MySimpleProfile = observer(() => {
	const { user, company } = useMst();
	const { t } = useTranslation();
	const tr = useCallback((name) => t(`userDashboard.${name}`), [t]);

	return (
		<Card className='profile_card' stretch>
			<CardHeader>
				<CardTitle>{tr('userInfo')}</CardTitle>
			</CardHeader>
			<CardBody>
				<strong className='txt_name'>{getPersonDisplayName(user.me) || ''}</strong>
				<div className='txt_team'>{getLocalizedFieldOrI18n(user?.me, 'userDepartment')} {user?.me?.userRank && ` | ${getLocalizedFieldOrI18n(user.me, 'userRank')}`}</div>
				<div className='info_box'>
					<Icon icon='AccountCircle' size='lg' />
					<span>{company?.get?.companyNumber || '-'}</span>
				</div>
				<div className='info_box'>
					<Icon icon='MailOutline' size='lg' />
					<span>{user?.me?.email || '-'}</span>
				</div>
			</CardBody>
		</Card>
	);
});

export default MySimpleProfile;
